/**
 * index.tsx
 * Point d'entrée React - Monte l'application dans le DOM
 */
import { createRoot } from 'react-dom/client';
import { AppWithRouter } from './App';
import { logger } from './utils/ProfessionalLogger';
import './styles/main.css';
// Importer le script d'analyse des logs pour le rendre disponible dans la console
import './utils/analyzeDebugLogs';

/**
 * Monte l'application React dans le container
 * Compatible avec la migration progressive
 */
function mountReactApp() {
  const container = document.getElementById('root');

  if (!container) {
    logger.error('Container #root non trouvé');
    return;
  }

  const root = createRoot(container);
  // P3 FIX CRITIQUE : PAS de React.StrictMode.
  // Le double-montage intentionnel de StrictMode (dev) race sur le lock interne
  // `navigator.locks` de `supabase.auth.getSession()`, provoquant un deadlock :
  // getSession() ne résout jamais → la session stockée n'est jamais restaurée
  // → l'utilisateur est rejeté au login à chaque reload (bug "ça charge pas").
  // Retirer StrictMode est le correctif standard pour Supabase Auth + React 18.
  root.render(<AppWithRouter />);

  logger.info('Application React montée');
}

// Attendre que le DOM soit prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountReactApp);
} else {
  mountReactApp();
}
